import _regeneratorRuntime from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import 'cross-fetch/polyfill';
var defaultFetchOpts = {
  referrerPolicy: 'origin'
};
export var getFetchOptions = function getFetchOptions() {
  return defaultFetchOpts;
};
export var setFetchOptions = function setFetchOptions(ops) {
  return Object.assign(defaultFetchOpts, ops);
};
export function fetchWrapper(_x, _x2) {
  return _fetchWrapper.apply(this, arguments);
}

function _fetchWrapper() {
  _fetchWrapper = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(input, init) {
    var fetchOpts, fetchResult;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetchOpts = {};
            Object.assign(fetchOpts, init, defaultFetchOpts);
            _context2.next = 4;
            return fetch(input, fetchOpts);

          case 4:
            fetchResult = _context2.sent;
            return _context2.abrupt("return", fetchResult);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchWrapper.apply(this, arguments);
}

export function hostMatches(host, pattern) {
  if (typeof pattern === 'string') return pattern === host;
  return pattern.exec(host);
}
export function createApiKeyMiddleware(_ref) {
  var apiKey = _ref.apiKey,
      _ref$host = _ref.host,
      host = _ref$host === void 0 ? /(.*)api(.*)\.stacks\.co$/i : _ref$host,
      _ref$httpHeader = _ref.httpHeader,
      httpHeader = _ref$httpHeader === void 0 ? 'x-api-key' : _ref$httpHeader;
  return {
    pre: function pre(context) {
      var reqUrl = new URL(context.url);
      if (!hostMatches(reqUrl.host, host)) return;
      var headers = new Headers(context.init.headers);
      headers.set(httpHeader, apiKey);
      context.init.headers = headers;
    }
  };
}

function argsForCreateFetchFn(args) {
  var fetchLib = fetchWrapper;
  var middlewares = [];

  if (args.length > 0 && typeof args[0] === 'function') {
    fetchLib = args.shift();
  }

  if (args.length > 0) {
    middlewares = args;
  }

  return {
    fetchLib: fetchLib,
    middlewares: middlewares
  };
}

export function createFetchFn() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var _argsForCreateFetchFn = argsForCreateFetchFn(args),
      fetchLib = _argsForCreateFetchFn.fetchLib,
      middlewares = _argsForCreateFetchFn.middlewares;

  var fetchFn =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(url, init) {
      var _a, fetchParams, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, middleware, result, response, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _middleware, _result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fetchParams = {
                url: url,
                init: init !== null && init !== void 0 ? init : {}
              };
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 4;
              _iterator = middlewares[Symbol.iterator]();

            case 6:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 16;
                break;
              }

              middleware = _step.value;

              if (!(typeof middleware.pre === 'function')) {
                _context.next = 13;
                break;
              }

              _context.next = 11;
              return Promise.resolve(middleware.pre(Object.assign({
                fetch: fetchLib
              }, fetchParams)));

            case 11:
              result = _context.sent;
              fetchParams = result !== null && result !== void 0 ? result : fetchParams;

            case 13:
              _iteratorNormalCompletion = true;
              _context.next = 6;
              break;

            case 16:
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 22:
              _context.prev = 22;
              _context.prev = 23;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 25:
              _context.prev = 25;

              if (!_didIteratorError) {
                _context.next = 28;
                break;
              }

              throw _iteratorError;

            case 28:
              return _context.finish(25);

            case 29:
              return _context.finish(22);

            case 30:
              _context.next = 32;
              return fetchLib(fetchParams.url, fetchParams.init);

            case 32:
              response = _context.sent;
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context.prev = 36;
              _iterator2 = middlewares[Symbol.iterator]();

            case 38:
              if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                _context.next = 48;
                break;
              }

              _middleware = _step2.value;

              if (!(typeof _middleware.post === 'function')) {
                _context.next = 45;
                break;
              }

              _context.next = 43;
              return Promise.resolve(_middleware.post({
                fetch: fetchLib,
                url: fetchParams.url,
                init: fetchParams.init,
                response: (_a = response === null || response === void 0 ? void 0 : response.clone()) !== null && _a !== void 0 ? _a : response
              }));

            case 43:
              _result = _context.sent;
              response = _result !== null && _result !== void 0 ? _result : response;

            case 45:
              _iteratorNormalCompletion2 = true;
              _context.next = 38;
              break;

            case 48:
              _context.next = 54;
              break;

            case 50:
              _context.prev = 50;
              _context.t1 = _context["catch"](36);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t1;

            case 54:
              _context.prev = 54;
              _context.prev = 55;

              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }

            case 57:
              _context.prev = 57;

              if (!_didIteratorError2) {
                _context.next = 60;
                break;
              }

              throw _iteratorError2;

            case 60:
              return _context.finish(57);

            case 61:
              return _context.finish(54);

            case 62:
              return _context.abrupt("return", response);

            case 63:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 18, 22, 30], [23,, 25, 29], [36, 50, 54, 62], [55,, 57, 61]]);
    }));

    return function fetchFn(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  return fetchFn;
}